import { render } from "./EmployersView.vue?vue&type=template&id=6e46f72c&ts=true"
import script from "./EmployersView.vue?vue&type=script&lang=ts"
export * from "./EmployersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__